import React from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import { CommonButton } from '../../components/buttons';
import UploadDocumentScreen from './UploadDocumentScreen';
// import { displayCustomError } from '../../../src/actions/utilAction'
import { UploadDocuments } from './actions/SchedulingActions';
/**
 * Dialog content can be scrollable.
 */
class UploadDocumentModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      file: null,
      base64Img: null,
      base64String: '',
      isValidFileSize: false,           
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  
  }


  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function (evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }


  calculateFileSizehandler = (files) => {
    let totalFileSize = 0;
    let fileSizeInKB = 0;
    // @desc - define const max upload file size 5MB
    let totalFileSizeInMB = 0;
    const fileSize5MB = 20.00;
    files.map((obj, i) => {
      totalFileSize = totalFileSize + obj.size;
      totalFileSizeInMB = ((totalFileSize / 1024) / 1024).toFixed(2);
      fileSizeInKB = Math.round(obj.size / 1024); // converted bytes(incoming file size) to KB.
      // 1024kb = 1MB
      let fileSizeInMB = Math.round((obj.size / 1024) / 1024);
      let fileSizeInMBFixTo2Decimal = fileSizeInMB.toFixed(2);
      return fileSizeInKB >= 1024 ? `${fileSizeInMBFixTo2Decimal}MB` : `${fileSizeInKB}KB`;
    });

    if (parseFloat(fileSizeInKB) === 0.00 || parseFloat(totalFileSizeInMB) > parseFloat(fileSize5MB)) {
      this.setState({ isValidFileSize: false });
    } else {
      this.setState({ isValidFileSize: true });
    }
  };

  getBase64(file, onLoadCallback) {
    return new Promise(function(resolve, reject) {
      let reader = new FileReader();
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  


  onSubmitHandler = (formData) => {   
    let self = this;
    let uploadDocumentObj = {};

    if(this.props.uploadDocumentObj === null)
    {
      let fileArr = this.refs.child.handleClick();
      let base64Array = [];
      let base64String = '';
      let objInside = {};
    
      fileArr.forEach((obj) => {
        let fileExtension = obj.name.split('.').pop().toLowerCase();
        let promise = this.getBase64(obj);
        promise.then(function (result) {
          let base64pre = `${result}`;
          let newBase64pre = base64pre.replace(/^data:([a-z]+\/[a-z0-9-+.]+(;[a-z-]+=[a-z0-9-]+)?)?(;base64)?,/, '');
          let finalBase64pre = `"${newBase64pre}": "${fileExtension}"`;
          base64String = `${finalBase64pre}`;
          base64Array.push(base64String);

          objInside = base64Array.reduce(function (acc, cur, i) {
            acc[i] = cur;
            return acc;
          }, {});

          uploadDocumentObj = {
            'PatientAppointmentId': self.props.PatientAppointmentId,
            'PatientEncounterId': self.props.PatientEncounterId,
            'base64': objInside,                      
          };
          if (base64Array.length === fileArr.length) {
            self.props.UploadDocuments(uploadDocumentObj);
          }
        });
      });
    }
    else
    {
      uploadDocumentObj = {
        'id': this.props.uploadDocumentObj.id,
        'PatientAppointmentId': this.props.PatientAppointmentId,
        'PatientEncounterId': this.props.PatientEncounterId,
        'base64': {},       
      };     
      
      self.props.UploadDocuments(uploadDocumentObj);
    }

    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }
    this.props.closeDialog();    
  } 

  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.uploadDocumentObj !== null || this.state.isValidFileSize ?      
      <CommonButton
        label={this.props.uploadDocumentObj !== null ? 'Update' : 'Upload'}
        type="submit" primary={true}
        onTouchTap={handleSubmit(this.onSubmitHandler.bind(this))} /> :
        <CommonButton primary={true} className="loader_btn" disabled={true} label="Upload" />;
    const actions = [
      <CommonButton className="mr-15 grey_btn" label="Cancel" onTouchTap={this.handleClose} />,
      submitButton,
    ];
    return (
      <div>
        <Dialog
          className="custom_modal"
          title={this.props.uploadDocumentObj !== null ? 'Edit Uploaded Document' : 'Upload Document'}
          modal={false}
          open={this.state.open}
          actions={actions}
          autoScrollBodyContent={true}
        >
          <div className="row">
            <div className="col-sm-12">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
                
                {this.props.uploadDocumentObj === null ?
                  <div className="row">
                    <div className='col-sm-12 require mt-35'>
                      <UploadDocumentScreen ref="child" calculateFileSizehandler={this.calculateFileSizehandler.bind(this)} />
                    </div>
                  </div>
                : null}
              </form>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

// const selector = formValueSelector('UploadDocumentModalForm');
const mapStateToProps = (state, ownProps) => {
  let initialData = null;   
  return {
    initialValues: initialData, 
    // uploadDocumentObj: ownProps.PatientAppointmentId ? ownProps.PatientAppointmentId : null,
    PatientAppointmentId: ownProps.PatientAppointmentId ? ownProps.PatientAppointmentId : 0,
    PatientEncounterId: ownProps.PatientEncounterId ? ownProps.PatientEncounterId : 0,
    loading: state.patient.loading,
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
  }

};


UploadDocumentModal = reduxForm({
  form: 'UploadDocumentModalForm', // a unique identifier for this form
  //validate,
  enableReinitialize: true,
})(UploadDocumentModal);

export default connect(mapStateToProps, { UploadDocuments })(UploadDocumentModal);



// WEBPACK FOOTER //
// ./src/modules/scheduling/UploadDocument_Modal.js